/* eslint-disable max-len */
import { CQ_ACTION_CODES, CQ_POTS } from '../../../catalogConstants';
import { STRING_KEYS } from '../../common';
import { USER_TYPE } from '../../../bitConstants/constants';

export const localizedStrings = {
  common: {
    everyMainSelection: {
      [STRING_KEYS.se.risk.subject]: 'TELCOBI FTTR Riesgo Error 800',
      [STRING_KEYS.se.order.subject]: 'TELCOBI FTTR Error TELCO',
      [STRING_KEYS.stepTitles.chooseNumberOTP]: 'Firma del contrato',
      [STRING_KEYS.chooseNumberOTP.infoBarData.text]: 'Te enviaremos un SMS al siguiente número para realizar la firma del contrato.',
      [STRING_KEYS.summary.staticDirectDebit]: 'El pago de este servicio se realizará en tu factura Movistar.',
      [STRING_KEYS.summary.cart.pocDuration]: 'Permanencia {duration} meses',
      [STRING_KEYS.summary.mainActionSelected.title]: 'Dirección de instalación',
      [STRING_KEYS.summary.productBarInfo.additionalInfoText]: 'Dirección',
      [STRING_KEYS.summary.productBarInfo.text]: '',
      [STRING_KEYS.legalNSubmit.buttonText]: 'Ver y firmar contrato',
      [STRING_KEYS.deviceInstallation[CQ_POTS.INSTALLATION_POT.INSTALLATION_ID].cartText]: 'Instalación Fibra FTTR',
      [STRING_KEYS.deviceSummaryCart.hguWithoutCost]: 'Router Smart WiFi 6',
      [STRING_KEYS.provisionalAgreement.title]: '',
      [STRING_KEYS.provisionalAgreement.pdfLinkText]: 'Descarga del resumen del contrato (PDF).',
      [STRING_KEYS.summary.cart.pocDuration]: '{duration} cuotas',
      [STRING_KEYS.genesys.campaign]: 'ret-genesys-fttr',
    },
    [`mainSelection_${CQ_ACTION_CODES.REGISTER}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.PORTABILITY}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.MIGRATION}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.ACTIVATE_LINE}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.UPGRADE_INCLUDED_LINE}`]: {
    },
  },
  [`user_${USER_TYPE.TELCO}`]: {
    everyMainSelection: {
    },
    [`mainSelection_${CQ_ACTION_CODES.REGISTER}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.PORTABILITY}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.MIGRATION}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.ACTIVATE_LINE}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.UPGRADE_INCLUDED_LINE}`]: {
    },
  },
  [`user_${USER_TYPE.OPEN}`]: {
    everyMainSelection: {
    },
    [`mainSelection_${CQ_ACTION_CODES.REGISTER}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.PORTABILITY}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.MIGRATION}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.ACTIVATE_LINE}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.UPGRADE_INCLUDED_LINE}`]: {
    },
  },
  selfEmployed: {
    everyMainSelection: {
      [STRING_KEYS.se.risk.subject]: 'TELCOBI FTTR Riesgo Error 800 AU',
      [STRING_KEYS.se.order.subject]: 'TELCOBI FTTR Error TELCO AU',
    },
  },
};
